module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAORJREFUSA1jZACCSZOWyPxm/NnF8P+/w38GBkmQGLmAkYHhOQMj4wHW/+xleXkxTxgnzQYa/v3nGQam//1MrOyLCtNjn5NrOEhf/8zFkv9+/4xj+MdYyMrAbsLYO3nuMgbG/xeLc1I6KTEYXW/vlDnlDP8Z9ZlAwQJyOboCSvlgM4FmM/RMmgMMdtoAkNlMtDEaYeqoBYiwwMEaDSIcAYMQHg0iRFjgYI0GEY6AQQgPgyAC1aGgag7hKeqwQGaCzGYCVdDgOpQ65sJNAZsJNJsFVPv//v/zDLAOZaBJpQ+ykpbNFgC+k14rnrcmywAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/choose_no.png
// module id = Js9J
// module chunks = 1